import { Card } from '../../components/ui'
import { Book, FileText, Video, ExternalLink } from 'lucide-react'

export const PlatformGuide = () => {
    return (
        <div className="p-8 max-w-7xl mx-auto bg-gray-50 min-h-screen">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center gap-3">
                    <Book className="text-indigo-600" />
                    Handleiding & Documentatie
                </h1>
                <p className="text-gray-500">Documentatie voor Super Admins en Platform beheerders.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <Card className="p-6 hover:shadow-lg transition-shadow cursor-pointer group">
                    <div className="bg-blue-100 w-12 h-12 rounded-xl flex items-center justify-center text-blue-600 mb-4 group-hover:scale-110 transition-transform">
                        <FileText size={24} />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Platform Beheer</h3>
                    <p className="text-gray-500 mb-4">Leer hoe je tenants beheert, abonnementen configureert en systeemdiensten monitort.</p>
                    <span className="text-blue-600 font-bold text-sm flex items-center gap-1">Lees meer <ExternalLink size={14} /></span>
                </Card>

                <Card className="p-6 hover:shadow-lg transition-shadow cursor-pointer group">
                    <div className="bg-green-100 w-12 h-12 rounded-xl flex items-center justify-center text-green-600 mb-4 group-hover:scale-110 transition-transform">
                        <FileText size={24} />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Support Systeem</h3>
                    <p className="text-gray-500 mb-4">Richtlijnen voor het afhandelen van support tickets en veelvoorkomende gebruikersproblemen.</p>
                    <span className="text-green-600 font-bold text-sm flex items-center gap-1">Lees meer <ExternalLink size={14} /></span>
                </Card>

                <Card className="p-6 hover:shadow-lg transition-shadow cursor-pointer group">
                    <div className="bg-red-100 w-12 h-12 rounded-xl flex items-center justify-center text-red-600 mb-4 group-hover:scale-110 transition-transform">
                        <Video size={24} />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Video Tutorials</h3>
                    <p className="text-gray-500 mb-4">Bekijk video's over geavanceerde functionaliteiten van het ProPoule platform.</p>
                    <span className="text-red-600 font-bold text-sm flex items-center gap-1">Bekijk nu <ExternalLink size={14} /></span>
                </Card>
            </div>

            <div className="mt-12 bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Snelle Links</h3>
                <ul className="space-y-3">
                    <li><a href="#" className="text-indigo-600 hover:underline">API Documentatie (Swagger)</a></li>
                    <li><a href="#" className="text-indigo-600 hover:underline">Database Schema & Relaties</a></li>
                    <li><a href="#" className="text-indigo-600 hover:underline">Mollie & Stripe Dashboard Login</a></li>
                    <li><a href="#" className="text-indigo-600 hover:underline">Contactgegevens Hoofdkantoor</a></li>
                </ul>
            </div>
        </div>
    )
}
